$(document).ready(function(){
	if($('#importForm').length) {
		$('#importForm').on('submit', function(e){
			$(this).find('button[type=submit]').prop('disabled', true);
			$(this).find('.uploadMessage').show();
		})
	}
})